import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResult220625 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination Results22/06/2025</h3>
      <br />
      <br />



        <div><Link to='/conduct-surachett'>1. AAT  7541  MR.SURACHET THAREEPHUT(PASS with Distinction)---Accquired rank SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-santis'>2. AAT  7518  MR.SANTI SIRISAK(PASS)---Accquired rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>3. AAT  7369  MR.JACQUES DU PLESSIS(PASS with Distinction)---Accquired rank 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>4. AAT  7847  MR.WANNATOUCH PRASERT(PASS with Distinction)---Accquired rank 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>5. AAT  7951  MS.NAPASANUN VONGVIVAT(PASS)---Accquired rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>6. AAT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL(PASS)---Accquired rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-manussaporne'>7. AAT  7942  MS.MANUSSAPORN  EKVISIT(PASS)---Accquired rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>8. AAT  8007  MR.KARNT SRISUWAN(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>9. AAT  8008  MR.PAKAWAD NANTAJURAPLO(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>10. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-praewpuns'>11. AAT  8010  PO.PRAEWPUN SUWANNAKOT(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-riradav'>12. AAT  8011  PO.RIRADA VANITWORACHOT(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-suphodh'>13. AAT  8012  CPO.SUPHOD HARASAN(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-kittipatw'>14. AAT  8013  MR.KITTIPAT  WIRIYA(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-orawanp'>15. AAT  8014  MS.ORAWAN PONGPRUEKSAPATTANA(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-sirawichu'>16. AAT  8015  MR.SIRAWICH  UDOMKANA(PASS)---Accquired rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pats'>17. AAT  8016  MR.PAT SUTHAPUNNAKUL(PASS)---Accquired rank 10KYU</Link></div>
        <br />







        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResult220625;
